import { z } from "zod";

export const TermsSchema = z.object({
    id: z.coerce.number(),
    terms: z.string().optional().nullable(),
    version: z.number().optional().nullable(),
    created_at: z.string().optional().nullable(),
});

export type Terms = z.infer<typeof TermsSchema>;
